<template>
  <div>
    <article-group v-if="project"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ArticleGroup from '@/components/coding-admin/article-group';
export default {
  name: 'ProjectArticleGroup',
  components: {'article-group': ArticleGroup},

  mounted() {
    const projectUid = this.$route.params.project_uid;
    // this.$emit('setHeaderSecondaryName', 'Groups');
  },

  computed: {
    ...mapState({
      user: state => state.user.user.data,
      project: state => state.projects.project.data
    }),
  },
};
</script>